import TextUnderlineIcon from '@atlaskit/icon/core/text-underline';
import * as React from 'react';

export function SvgUnderline() {
  return <TextUnderlineIcon label="" testId="ads-refreshed-icon" />;
}
